import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';
import { refresh } from 'ionicons/icons';
import { getShoppingCart } from '../utils/functions';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

export function setDataConcat(items, name) {
    return {
        type: ActionTypes.DATA_WITH_PAGINATION_CONCAT,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active,
            pos_location_id: data.pos_location_id ? data.pos_location_id : null,
        }));
        getRequest(data, controller).then(
            (response) => {

                if (data.typeOption == "getDayRuteFull") {
                    /*
                        if (data.pages == 0) {
                            dispatch(setData({ contacts: response.data, data_pagin: response.data.data }));
                        } else {
                            dispatch(setData({ contacts: response.data }));
                            dispatch(setDataConcat(response.data.data, 'data_pagin'));
                        }

                    */
                    window.localStorage.setItem('ari_app_permissions', response.data.permissions ? JSON.stringify(response.data.permissions) : '[]');

                    if (data.pages == 0) {
                        dispatch(setData({
                            contacts: response.data,
                            data_pagin: response.data.data,

                            refresh_list: false,
                            concat_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            contacts: response.data,

                            refresh_list: false,
                            concat_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },

                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin'));
                    }
                } else if (data.typeOption == "get_catalogo_products") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            products: response.data,
                            data_pagin_products: response.data.data,

                            refresh_list: false,
                            concat_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            products: response.data,

                            refresh_list: false,
                            concat_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_products'));
                    }

                } else if (data.typeOption == "get_data_default") {
                    let data_default = response.data;
                    //subcategories
                    let categoories = response.data.categories ? response.data.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;

                    let units = response.data.units_array ? response.data.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;

                    let brands = response.data.brands ? response.data.brands : [];
                    data_default['brands'] = brands;

                    let categories_expenses = response.data.categories_expenses ? response.data.categories_expenses : [];
                    data_default['categories_expenses'] = categories_expenses;

                    dispatch(setData({
                        data_default: data_default,
                        refresh_list: false,
                        concat_list: true,
                        loading: { Msg: 'Cargando...', isOpen: false },
                    }));
                    window.localStorage.setItem('ari_app_permissions', response.data.permissions ? JSON.stringify(response.data.permissions) : '[]');
                    window.localStorage.setItem('ari_app_enabled_modules', response.data.enabled_modules ? JSON.stringify(response.data.enabled_modules) : '{}');

                    //////valorar de aqui abajo
                } else if (data.typeOption == "get_data_product") {
                    // dispatch(setData({ products_filter: response.data.data }));
                } else if (data.typeOption == "getSellRutas") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            transactions: response.data,
                            data_pagin_transactions: response.data.data,

                            refresh_list: false,
                            concat_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({

                            transactions: response.data,

                            refresh_list: false,
                            concat_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_transactions'));
                    }
                } else if (data.typeOption == "getNotSellRutas") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            transactions: response.data,
                            data_pagin_transactions: response.data.data,

                            refresh_list: false,
                            concat_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({

                            transactions: response.data,

                            refresh_list: false,
                            concat_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_transactions'));
                    }
                } else if (data.typeOption == "print_transaction") {

                    dispatch(setData({
                        refresh_list: false,
                        concat_list: false,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        response: { Msg: '', success: response.data.success, receipt: response.data.receipt.html_content ? response.data.receipt.html_content : null },
                    }));

                } else if (data.typeOption == "getSalesReport") {
                    dispatch(setData({
                        minirepoort: response.data.data,
                        refresh_list: false,
                        concat_list: false,
                        loading: { Msg: 'Cargando...', isOpen: false },
                    }));
                } else if (data.typeOption == "get_customer_dues") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            contacts: response.data,
                            data_pagin: response.data.data,
                            refresh_list: false,
                            concat_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            contacts: response.data,
                            refresh_list: false,
                            concat_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },

                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin'));
                    }
                } else if (data.typeOption == "get_customer_abonos") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            paymentsData: response.data,
                            data_pagin_paymentsData: response.data.data,
                            refresh_list: false,
                            paymentDatalist: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            paymentsData: response.data,
                            refresh_list: false,
                            paymentDatalist: true,
                            loading: { Msg: 'Cargando...', isOpen: false },

                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_paymentsData'));
                    }
                } else if (data.typeOption == "print_payment") {
                    dispatch(setData({
                        refresh_list: false,
                        concat_list: false,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        response: {
                            Msg: '',
                            success: response.data.success,
                            receipt: response.data.html_content ? response.data.html_content : null
                        },
                    }));
                }
            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active
        }));

        postRequest_(data, controller).then(
            (response) => {

                if (data.typeOption == "saveDataContact" || data.typeOption == "not_sell") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        concat_list: false,
                    }))
                } else if (data.typeOption == "saveOrder") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success, receipt: response.data.receipt.html_content ? response.data.receipt.html_content : null },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        concat_list: false,
                    }))
                } else if (data.typeOption == "save_payment_dues") {
                    //console.log(response.data, 'server');
                    dispatch(setData({
                        refresh_list: true,
                        concat_list: false,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        response: {
                            Msg: '',
                            success: response.data.success,
                            receipt: response.data.html_content ? response.data.html_content : null
                        },
                    }));

                }


            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

const addshoppingcart = (product) => {
    return (dispatch) => {
        let arrayshoppingcart = !getShoppingCart() ? [] : getShoppingCart();
        let array_shoppingcart_tem = [];
        let exit = false;
        let position = 0;
        if (arrayshoppingcart && arrayshoppingcart.length > 0) {
            for (var j = 0; j <= arrayshoppingcart.length - 1; j++) {
                if (arrayshoppingcart[j]['id'] == product.id) {
                    arrayshoppingcart[j]['quantity'] = parseFloat(arrayshoppingcart[j]['quantity']) + parseFloat(product.quantity);
                    array_shoppingcart_tem.push(arrayshoppingcart[j]);
                    exit = true;
                } else {
                    array_shoppingcart_tem.push(arrayshoppingcart[j]);
                }
            }
        };

        if (!exit) {
            array_shoppingcart_tem.push(product);
        }

        window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify(array_shoppingcart_tem));
        dispatch(setData({
            shoppingcart: array_shoppingcart_tem,
            response: exit ? { Msg: "Se incremento la cantidad del producto", success: 1 } : { Msg: "Agregado al Carrito", success: 1 },
            simpleToast: true,
            refresh_shopping: true,
            view_active: product.view_active
        }));
    }
};

const removedshoppingcart = (product) => {
    return (dispatch) => {
        let arrayshoppingcart = !getShoppingCart() ? [] : getShoppingCart();
        let array_shoppingcart_tem = [];
        let exit = false;
        let position = 0;
        if (arrayshoppingcart && arrayshoppingcart.length > 0) {
            for (var j = 0; j <= arrayshoppingcart.length - 1; j++) {
                if (arrayshoppingcart[j]['id'] != product.id) {
                    array_shoppingcart_tem.push(arrayshoppingcart[j]);
                }
            }
        };

        window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify(array_shoppingcart_tem));
        dispatch(setData({
            shoppingcart: array_shoppingcart_tem,
            response: { Msg: "Producto Removido del Carrito", success: 1 },
            simpleToast: true,
        }));
    }
};
const removedshoppingcartall = (pos_location_id) => {
    return (dispatch) => {
        let arrayshoppingcart = !getShoppingCart() ? [] : getShoppingCart();
        let array_shoppingcart_tem = [];
        window.localStorage.setItem('ari_app_shoppingcart', JSON.stringify([]));
        dispatch(setData({
            pos_location_id: pos_location_id,
            shoppingcart: array_shoppingcart_tem,
            response: { Msg: "Se limpio el Carrito", success: 1 },
            simpleToast: true,
            refresh_list: true,
            view_active: 'dashboard_pos/products'
        }));
    }
};

export default {
    get_,
    post_,
    setData,
    addshoppingcart,
    removedshoppingcart,
    removedshoppingcartall
}